import styled from 'styled-components';
import media from '../../../../../constants/media';
import { Columns } from '../../../../base/grid';

export const Wrapper = styled.div``;

export const FieldColumns = styled(Columns)`
	display: none;
	${media.tablet`
		display: flex;
	`};
`;

export const WeightInfo = styled.div`
	display: flex;
	align-items: center;

	svg {
		max-height: 6.7rem;
		max-width: 7.2rem;
		margin-right: 2rem;
	}
`;

export const WeightInfoText = styled.div`
	max-width: 15.5rem;
`;

export const WeightEstimateInfo = styled.p`
	color: ${({ theme }) => theme.colors.textColor};
	margin-bottom: 2rem;
`;

export const VolumeSection = styled.div`
	margin-top: 2rem;
	margin-bottom: 2rem;
`;


export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 6rem;

	${media.mobileOnly`
		flex-direction: column;

		button {
			width: 100%;

			&:first-child {
				margin-bottom: 1.5rem;
			}
		}
	`};
`;
